// @flow
import { createContext } from 'react';

export const SPForecastStatusContext = createContext({});
